import { render, staticRenderFns } from "./teacher-upload-fail-list.vue?vue&type=template&id=4accd5da&scoped=true"
import script from "./teacher-upload-fail-list.vue?vue&type=script&lang=js"
export * from "./teacher-upload-fail-list.vue?vue&type=script&lang=js"
import style0 from "./teacher-upload-fail-list.vue?vue&type=style&index=0&id=4accd5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4accd5da",
  null
  
)

export default component.exports